import React from 'react'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button } from 'reactstrap'

import { login } from './services'
import { handleError } from '../../helpers'
import { userLogin } from './actions'

export default function Login() {
	const { register, handleSubmit, formState: { errors } } = useForm()
	const dispatch = useDispatch()

	const onSubmit = values => {
		login(values)
			.then(res => {
				dispatch(userLogin(res.data))
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<h5 className="mb-10">Iniciar Sesión</h5>
			<p className="text-muted mb-20">Bienvenido de nuevo. Ingrese su usuario y contraseña para ingresar al <b className='text-primary'>CEN Financiero Spring</b>.</p>
			<Form className="text-left" onSubmit={handleSubmit(onSubmit)}>
				<Form.Group className='form-group'>
					<Form.Label>Nombre de Usuario <span className="text-primary">*</span></Form.Label>
					<Form.Control 
						{...register('username',{ required: true })}
						type="number"
						placeholder="Escriba su usuario de acceso"
					/>
					{ errors.username && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Form.Group className='form-group'>
					<Form.Label>Contraseña de Acceso <span className="text-primary">*</span></Form.Label>
					<Form.Control
						{...register('password',{ required: true })}
						type="password"
						placeholder="Escriba su contraseña"
					/>
					{ errors.password && <Form.Text className="text-warning">Este campo es requerido.</Form.Text> }
				</Form.Group>
				<Button color="primary" className="full-width">Iniciar Sesión</Button>
			</Form>
		</React.Fragment>
	)
}